import React from "react";
import { Table, Pagination } from "antd";

const TablaRespuestas = ({
  loading,
  respuestas = [],
  pagination = { current: 1, pageSize: 3, total: 0 },
  onPaginationChange,
}) => {
  const columns = [
    {
      title: "Cliente",
      dataIndex: "cliente",
      key: "cliente",
    },
    {
      title: "Pregunta",
      dataIndex: "pregunta",
      key: "pregunta",
    },
    {
      title: "Respuesta",
      dataIndex: "respuesta",
      key: "respuesta",
    },
  ];

  return (
    <>
    <Table
      columns={columns}
      dataSource={respuestas}
      rowKey="id"
        pagination={false}
      loading={loading}
    />
      {pagination.total > 0 && (
        <Pagination
          current={pagination.current}
          pageSize={pagination.pageSize}
          total={pagination.total}
          showSizeChanger={true}
          showQuickJumper={true}
          showTotal={(total) => `Total: ${total} registros`}
          pageSizeOptions={["3", "5", "10", "25"]}
          onChange={(page, pageSize) => onPaginationChange(page, pageSize)}
          style={{ marginTop: 16, textAlign: "right" }}
        />
      )}
    </>
  );
};

export default TablaRespuestas; 
